import React from "react";

const Sidebar = ({
  showSidebar,
  isMobile,
  chatRooms,
  activeChat,
  onChatSelect,
  onToggleSidebar,
  getUnreadCount,
  chatRoomsLoading,
  unreadCount,
  setUnreadCount,
}) => {
  return (
    <div className="flex flex-col h-full">
      <div className="p-3 md:p-4 border-b border-gray-800 bg-black bg-opacity-40">
        <div className="flex items-center justify-between">
          <h2 className="font-bold text-base md:text-lg text-white flex items-center">
            <span className="bg-gradient-to-r from-purple-400 to-pink-500 bg-clip-text text-transparent">
              Chat Rooms
            </span>
            <span className="ml-2 text-xs py-0.5 px-2 bg-gray-800 rounded-full text-gray-400">
              {chatRooms.length}
            </span>
          </h2>
          {isMobile && (
            <button
              onClick={onToggleSidebar}
              className="text-gray-400 hover:text-purple-400 transition-colors p-2 -mr-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          )}
        </div>
      </div>

      <div className="overflow-y-auto flex-1 py-2 px-2">
        {chatRoomsLoading ? (
          <div className="flex items-center justify-center h-full">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-500"></div>
          </div>
        ) : chatRooms.length > 0 ? (
          chatRooms.map((room) => {
            const unreadCount = getUnreadCount(room._id);
            return (
              <div
                key={room._id}
                onClick={() => {
                  onChatSelect(room._id);
                  if (isMobile) onToggleSidebar();
                }}
                className={`group flex items-center p-3 md:p-4 mb-1 rounded-xl cursor-pointer transition-all duration-200 
                  hover:bg-gray-800/50 relative touch-manipulation
                  ${
                    activeChat === room._id
                      ? "bg-gray-800/80 shadow-md"
                      : "hover:translate-x-1"
                  }`}
              >
                <div className="flex items-center space-x-3 flex-1 min-w-0">
                  <div
                    className={`w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center flex-shrink-0
                      transition-all duration-200 group-hover:scale-105
                      ${
                        activeChat === room._id
                          ? "bg-gradient-to-br from-purple-600 to-purple-700"
                          : "bg-gray-700 group-hover:bg-gray-600"
                      }`}
                  >
                    <span className="text-white font-medium text-sm md:text-base">
                      {room.name && room.name[0]}
                    </span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-medium text-sm md:text-base text-white truncate">
                      {room.name}
                    </h3>
                    {/* Add status or last message preview if needed */}
                    {/* <p className="text-xs md:text-sm text-gray-400 truncate">
                      {room.status === "success"
                        ? "Completed"
                        : room.status === "closed"
                        ? "Closed"
                        : "Active"}
                    </p> */}
                  </div>
                  {unreadCount > 0 && (
                    <div className="ml-2 bg-purple-600 text-white text-xs font-medium px-2 py-1 rounded-full min-w-[1.25rem] text-center">
                      N
                    </div>
                  )}
                </div>
              </div>
            );
          })
        ) : (
          <div className="flex flex-col items-center justify-center h-full text-center px-4">
            <div className="text-gray-400 mb-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-12 w-12 mx-auto mb-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                />
              </svg>
              <p className="text-sm md:text-base">No chat rooms available</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
